import React, { createContext } from 'react';
import { platform } from './platform';
export var SSRContext = /*#__PURE__*/createContext({
  platform: null,
  userAgent: ''
});
export var SSRWrapper = function SSRWrapper(props) {
  var userAgent = props.userAgent,
      children = props.children; // TODO: Каждый раз создаётся новый объект для контекста – плохо

  var contextValue = {
    platform: platform(userAgent),
    userAgent: userAgent
  };
  return /*#__PURE__*/React.createElement(SSRContext.Provider, {
    value: contextValue
  }, children);
};
//# sourceMappingURL=SSR.js.map